import firebase from "../config/firebase";
import {saveAs} from 'file-saver';
import {ContentState, EditorState} from "draft-js";
import htmlToDraft from 'html-to-draftjs';
import config, {API_URL} from "../config";
import AxiosServices from "../networks/AxiosService";
import ApiUrlServices from "../networks/ApiUrlServices";
const qs = require('query-string');

export function setSessionStorage(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
    return true
}

export function getFirebaseToken() {
    const msg = firebase.messaging();
    return msg.requestPermission().then(() => {
        return msg.getToken();
    }).catch((err) => {
        return err;
    })
}

export function capitalizeFirstLetter(string) {
    if(string === undefined){
        return ''
    }else{
        return string.charAt(0).toUpperCase() + string.slice(1) + " ";
    }
}

export const secondToHours = (sec) => {
    return (sec / 3600).toFixed(2);
}

export const timeGet2 = (duration) => {
    const hours = `${Math.floor(duration / 3600)}`;
    let min = `${Math.floor((duration % 3600) / 60)}`;
    const secs = `${(duration % 3600) % 60}`;

    const finalString = `${getDigitsCard(hours, 'h')} ${getDigitsCard(min, 'm')} ${getDigitsCard(secs, "s")}`

    return finalString;
}

export const onlyHours = (duration) => {
    const hours = `${duration / 3600}`;

    return Number(duration) === 0 ? '0 Hour' : Number(hours).toFixed(2) + ' Hours';
}

const getDigitsCard = (hours, str) => {
    let finalString = `${hours === "0" ? "" : hours.length === 1 ? `0${hours}${str}` : `${hours}${str}`}`;
    if(!finalString && str === 's') {
        return "0s"
    }
    return finalString;
}


export const timeGet = (duration) => {
    const hours = Math.floor(duration / 3600);
    const mins = Math.floor((duration % 3600) / 60);
    const secs = (duration % 3600) % 60;

    const strHour = hours > 0 ? `${hours} Hours ` : "";
    const strMin = mins > 0 || hours > 0 ? `${mins} Mins ` : "";
    const strSec = secs > 0 || mins > 0 || hours > 0 ? `${secs} Secs` : "0 Sec";

    return strHour + strMin + strSec;
}

export const getMins = (duration) => {
    let digitTwo = false;
    let totalMins;
    const hours = Math.floor(duration / 3600);
    let min = Math.floor((duration % 3600) / 60);
    const secs = (duration % 3600) % 60;
    if (min.toString().length >= 2){
        digitTwo = true;
        if (digitTwo){
            totalMins = min + ":" + secs + "m"
        }
    }else{
        totalMins = "0"+ min + ":" + secs + "m"

    }
    return totalMins;
}

export const isImage = (value) => {
    let new_value = value.split('.');

    const extension = new_value[new_value.length - 1].toLocaleLowerCase();
    var imageTypes = ['jpg', 'jpeg', 'tiff', 'png', 'gif', 'bmp'];
    if (imageTypes.indexOf(extension) !== -1) {
        return true;
    }
    return false;
}

export const isVideo = (value) => {
    let new_value = value.split('.');

    const extension = new_value[new_value.length - 1].toLocaleLowerCase();
    var videoTypes = ['mp4', 'mov', 'wmv', 'flv', 'avi', 'webm', 'mkv', 'm3u8'];
    if (videoTypes.indexOf(extension) !== -1) {
        return true;
    }
    return false;
}

export const getUrlHls = (keyUrl) => {
    if(keyUrl.includes("ct-all")) {
        return keyUrl;
    }
    const baseUrl = API_URL.cloudfront_base_url;
    let url = keyUrl;
    const specialChars = {
        ";": "%3B",
        ",": "%2C",
        ":": "%3A",
        "&": "%26",
        "=": "%3D",
        "+": "%2B",
        "$": "%24",
        "#": "%23",
        "?": "%3F"
    }

    let urlList = url.split(".");
    urlList.pop();

    let urlList1 = urlList.join(".");
    urlList = urlList1.split("/");

    const fileName = urlList.pop();

    url = urlList.join("/");

    const burl = `${url}/hls/${fileName}_`;
    const ext = `_qvbr.m3u8`;

    const finalUrl = `${burl}${"Auto"}${ext}`;

    let specialEncoded = encodeURI(finalUrl);

    Object.entries(specialChars).map(([key, value]) => {
        specialEncoded = specialEncoded.replaceAll(key, value);
    })

    return `${baseUrl}${specialEncoded}`;
}

export function isLetter(str) {
    if (str !== undefined) return str.length === 1 && str.match(/[a-z]/i);
}

export function isPdf(llink) {
    const fileName = llink.split("/").pop();
    let a = fileName.split(".");
    let c = a.pop();

    if (c === "temppdf") {
        return true
    }
    return false;
}

export const getPdfEx = (name) => {
    let a = name.split(".");
    a.pop();
    a.push("pdf");
    a = a.join(".");

    return a;
}

export const resolveFileName = (url) => {
    let name = String(url).split("/").pop();
    if(String(url).split("/").length === 1) {
        name = url;
        return url;
    }
    let fName = name.split("_");
    fName.splice(0, 1);
    fName = fName.join("_");

    if (isPdf(url)) {
        fName = getPdfEx(fName);
    }
    return fName;
}

export function downloader(url) {
    const name = resolveFileName(url);
    saveAs(url, name);
}

export function downloaderPdf(url) {
    let fileName = url.split("/").pop();
    fileName = resolveFileName(fileName);
    // let a = getPdfEx(fileName);
    // console.log(url, a);
    saveAs(url, fileName);
}

export function parseHtmlToDraft(data) {
    if (data !== undefined) {
        const contentBlock = htmlToDraft(data);
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        return EditorState.createWithContent(contentState)
    }
}

export function truncate(source, size) {
    let d = source.split(".")
  // return source.length > size ? source.slice(0, size - 1) + "…" : source;
  return d[0].length > size ? d[0].slice(0, size - 1) + "…"+d[1] : source;
}


export function shortLetterShow(str, size) {
    let result = str?.length > size ?  str?.substr(0,size)+ "...." : str ;
    return result;
}

export const dateMonthYearCalculate = (timestamp) => {
    let d = new Date();
    let today = d.toLocaleString()
    let commmentDate = new Date(timestamp * 1000).toLocaleString();
    let currentDate = today.split(",")[0]
    let previousDate = commmentDate.split(",")[0]
    let diff = new Date(new Date(currentDate).getTime() - new Date(previousDate).getTime())
    let year = diff.getUTCFullYear() - 1970;
    let month = diff.getUTCMonth();
    let days = diff.getUTCDate() - 1;
    let result;
    if (year >= 2) {
        if (month >= 2) {
            if (days > 2) {
                result = `${year} years ${month} months ${days} days`
            } else {
                result = `${year} years ${month} months ${days} day`
            }
        } else if (month >= 1) {
            if (days > 2) {
                result = `${year} years ${month} month ${days} days`
            } else {
                result = `${year} years ${month} month ${days} day`
            }
        } else if (month >= 0) {
            if (days > 2) {
                result = `${year} years ${month} month ${days} days`
            } else {
                result = `${year} years ${month} month ${days} day`
            }
        }
    } else if (year === 1) {
        if (month >= 2) {
            if (days >= 2) {
                result = `${year} year ${month} months ${days} days`
            } else {
                result = `${year} year ${month} months ${days} day`
            }
        } else if (month >= 1 || month === 0) {
            if (days >= 2) {
                result = `${year} year ${month} month ${days} days`
            } else {
                result = `${year} year ${month} month ${days} day`
            }
        }
    } else if (year === 0) {
        if (month >= 2) {
            if (days >= 2) {
                result = `${month} months ${days} days`
            } else {
                result = `${month} months ${days} day`
            }
        } else if (month === 1) {
            if (days >= 2) {
                result = `${month} month ${days} days`
            } else {
                result = `${month} month ${days} day`
            }
        } else if (month === 0) {
            if (days >= 2) {
                result = `${days} days`
            } else {
                result = `${days} day`
            }
        }
    }
    // let result = `${years} ${months} ${days}`

    console.log(result)

    return result;

    console.log(diff.getUTCFullYear() - 1970); // Gives difference as year
    console.log(diff.getUTCMonth()); // Gives month count of difference
    console.log(diff.getUTCDate() - 1); // Gives day count of difference
}

const fileFormatValidator = (name, formatArr) => {
    let flag = false;
    formatArr.map(format => {
        if(name.includes(format)) {
            flag = true;
        }
    })

    return flag;
}

export const fileSizeValidator = (size, type, name, formatArr = []) => {
    const fileSizeMB = Math.round((size / 1024 / 1024));

    const baseFileSizeFormat = {
        "video": 500,
        "attachment": 50,
        "preview": 500,
        "image": 5
    }

    const filetype = {
        "video": [".mp4", ".m4v"],
        "attachment": [".zip", ".rar", ".tar"],
        "preview": [".mp4", ".m4v"],
        "image": ["image"]
    }

    if(name) {
        const formArr = formatArr.length ? formatArr : filetype[type];
        if(!fileFormatValidator(name, formArr)) {
            return "format_mismatch";
        }
    }

    if (!baseFileSizeFormat[type]) {
        return false;
    }

    if (fileSizeMB > baseFileSizeFormat[type]) {
        return false;
    }
    return true;
}

export const validateImageSize2 = async (file, cb) => {

    let img = new Image()
    img.src = window.URL.createObjectURL(file);
    img.onload = () => {
        cb(img)
    }
}


export const genericImageValidatorResizer = (file, config, setError, errObj, setImage, imageObj, e, onResizeImage, isNullErrorObj) => {

    const resolveAndSetErrors = (error) => {
        if (errObj) {
            setError(prev => ({
                ...prev,
                [errObj]: error
            }))
        }
        else {
            setError(error)
        }
    }

    const resolveAndSetImage = (editedFile) => {
        if (imageObj) {
            setImage(prev => ({
                ...prev,
                [imageObj]: editedFile
            }))
        }
        else {
            setImage(editedFile);
        }
    }

    const validation = fileSizeValidator(file.size, "image", file.type);
    if (validation === true) {
        validateImageSize2(file, (img) => {
            if (img.height >= config.height && img.width >= config.width) {
                resolveAndSetErrors("");
                validateImageSize2(file, async (img) => {
                    if (img.height > config.height || img.width > config.width) {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.addEventListener("load", () => {
                            onResizeImage(reader.result, file.name);
                        });

                        return;
                    }
                    else {
                        resolveAndSetImage(file);
                    }
                })
            }
            else {
                e.target.value = "";
                if (!isNullErrorObj) {
                    setImage({});
                }
                else {
                    setImage(null);
                }
                resolveAndSetErrors(`Image width and height can't be less than ${config.width}X${config.height}`);
            }
        })
    }
    else if(validation === false) {
        if (!isNullErrorObj) {
            setImage({});
        }
        else {
            setImage(null);
        }
        resolveAndSetErrors("Please select an image less than 5MB");
    }
    else if(validation === "format_mismatch") {
        e.target.value = "";
        resolveAndSetErrors(`Please select an image`)
    }
}

export const removeGarbageCharOnFileName = (fileName) => {
    const arr = fileName.split(".");
    const ext = arr.pop();

    let name = arr.join(".");
    const filterData = name.replace(/[^a-zA-Z0-9-_]/g, '');

    const finalStr = `${filterData}.${ext}`;
    return finalStr;
}

export const removeGarbageString = (fileName) => {
    return fileName.replace(/[^a-zA-Z0-9-_]/g, '');
}

export const iframeLink = (url) => {
    if(url.includes("/embed/")) {
        return url;
    }
    const first = "https://www.youtube.com/embed/";
    if(url.includes("youtube.com")) {
        const parsed = qs.parse(`?${url.split("?")[1]}`);
        return `${first}${parsed.v}`;
    }
    else if(url.includes("youtu.be/")) {
        const last = url.split("youtu.be/")[1];
        return `${first}${last}`
    }

    return false;
}

export const getPermission = (payload, reqUrl, setCookie, setUrl, url, loader=() => {}) => {
    AxiosServices.post(reqUrl, payload)
        .then(res => {
            const cookie = res.data.data;
            console.log(cookie);
            const options = {
                domain: "coderstrust.net",
                path: "/",
                secure: true,
            }
            for (const [key, value] of Object.entries(cookie)) {
                console.log(`${key}`, value, options);
                setCookie(`${key}`, value, options);
            }

            setTimeout(() => {
                setUrl(url);
            });

            loader(false);
        })
        .catch(err => {
            loader(false);
            setTimeout(() => {
                setUrl(url);
            });
            console.log(err);
        })
}

export const getPreviewUrl = (url) => {
    const url1 = config.API_URL.aws.s3_base_url_with_folder_name;
    const url2 = config.API_URL.aws.s3_base_url_with_folder_name_depricated;

    let finalUrl;

    if(url.includes(url1)) {
        finalUrl = `public/${url.split(url1)[1]}`
    }
    else if(url.includes(url2)) {
        finalUrl = `public/${url.split(url2)[1]}`;
    }
    else {
        return false;
    }
    return finalUrl;
}
